import { authDelete } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import { SlackAppIntegrationDeletionResponse } from "@pages/settings/types";

export const deleteSlackAppIntegration = (deploymentId: string) => {
  return authDelete<SlackAppIntegrationDeletionResponse>(
    `${DEPLOYMENT_URL}/${deploymentId}/slack/installations`
  );
};
